export default __webpack_public_path__ + "static/media/abp-electrical-bg.05b535b2.jpeg";